module.exports = __webpack_public_path__ + "static/media/partitions_lcs_10y_n.c5fda1e6.csv";